<template>
  <div class="mt-10">
    <h6 class="font font--money-label font--color_dark mb-md-6 pl-4 pl-md-0">Подарки от Модульбанка</h6>

    <div class="d-flex flex-md-row flex-column white pa-6 align-md-center justify-space-between" style="column-gap: 40px">
      <div class="d-flex flex-column flex-shrink-0" style="min-width: 25%">
        <span>Накоплено бонусов</span>
        <div class="d-flex flex-row align-center" style="column-gap: 16px; min-height: 70px">
          <template v-if="bonus_balance != null">
            <span class="bonuses-amount font--big">{{ Number(bonus_balance).toLocaleString('ru-ru') }}</span>
            <v-img src="@/assets/img/bonus-coin.svg" max-width="32px" max-height="32px" />
          </template>
          <v-progress-circular v-else indeterminate color="primary" width="3"></v-progress-circular>
        </div>
      </div>
      <div class="d-flex flex-column flex-shrink-1" style="color:#777c87">
        <span>Получайте бонусы за целевые действия и обменивайте их на подарки от Модульбанка</span>

        <div class="d-inline-block">
          <span>За что начисляются бонусы?</span>
          <v-tooltip top :max-width="widthTooltip">
            <template #activator="{on,props}">
              <v-icon class="ml-1" v-bind="props" v-on="on" small>mdi-help-circle-outline</v-icon>
            </template>

            <template #default>
              Вы будете получать бонусы за каждый открытый счет, активность ваших клиентов, стабильный статус рейтинга партнера, а также за селлеров и за постоянную работу в партнерской программе
            </template>
          </v-tooltip>
        </div>
      </div>

      <v-img class="d-none d-md-block" src="@/assets/img/bonus.png" max-height="138px" max-width="150px" />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    bonus_balance() {
      return this.$store.state.billing.bonus_balance;
    },

    widthTooltip() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return '75vw';
      }

      return '35vw';
    }
  }
}
</script>
